import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { SlotStatus } from './model';

const STYLES: Record<SlotStatus, string> = {
  rule: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  default: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  missing: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
};

export function StatusDot({ status, className }: { status: SlotStatus; className?: string }) {
  const color = status === 'rule' ? 'bg-emerald-500' : status === 'default' ? 'bg-amber-500' : 'bg-red-500';
  return <span className={cn('inline-block h-2 w-2 shrink-0 rounded-sm', color, className)} aria-hidden />;
}

/** Rounded-rect (never pill) source badge: Tanım / Varsayılan / Eksik. */
export function SourceBadge({ status, className }: { status: SlotStatus; className?: string }) {
  const { t } = useTranslation('postingRules');
  return (
    <span className={cn('inline-flex items-center rounded-md px-1.5 py-0.5 text-[11px] font-medium', STYLES[status], className)}>
      {t(`status.${status}`)}
    </span>
  );
}

export function Tag({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded-md border border-border bg-muted px-1.5 py-0.5 text-[11px] font-medium text-muted-foreground', className)}>
      {children}
    </span>
  );
}
